import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, Checkbox } from '@honda-canada/design-system-react';
import LabeledItem from './LabeledItem';
const LabeledCheckbox = ({ checked, dataTestId, disabled, name, onClick, ...itemProps }) => (_jsx(LabeledItem, { name: name, ...itemProps, onClick: onClick, children: _jsx(Box, { "data-testid": dataTestId, children: _jsx(Checkbox, { containerSize: "small", checked: checked, id: name, value: checked, name: name, disabled: disabled }) }) }));
export default LabeledCheckbox;
